/**
 * Chain tab selector component.
 * Manages the active chain state and emits change events.
 */

export type Chain = 'ethereum' | 'bitcoin' | 'solana';

export function initChainSelector(
  onChainChange: (chain: Chain) => void,
): { getActiveChain: () => Chain } {
  let activeChain: Chain = 'ethereum';

  const tabs = document.querySelectorAll<HTMLButtonElement>('.chain-tab');

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      const chain = tab.dataset['chain'] as Chain;
      if (!chain || chain === activeChain) return;

      // Update visual state
      tabs.forEach((t) => t.classList.remove('active'));
      tab.classList.add('active');

      activeChain = chain;
      onChainChange(chain);
    });
  });

  return {
    getActiveChain: () => activeChain,
  };
}
